export const environment = {
  production: false,
  apiUrl: '#{ApiUrl}#',
  notificationApiUrl: '#{NotificationApiUrl}#',
  deviceInfoUrl: '#{DeviceInfoUrl}#',
  featureFlags: {
    enableNotification: true,
    isDeviceVerificationEnabled: true
  },
  faceAuthPanel: 'http://127.0.0.1:8000/facenet-uat'
};
